import { createSelector } from 'reselect';
import { rootReducerStateKey } from '../rootReducer';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSlice = (state: { [x: string]: any }): any => state[rootReducerStateKey];

/**
 * Selector to check the mode of theme (dark or light)
 */
export const getModeTheme = () => createSelector(getSlice, slice => slice.mode);
